export default __webpack_public_path__ + "img/img_justin-01778462ab28ad2a5731007854a4d6e0.jpg";